module.exports = __webpack_public_path__ + "assets/img/approval.b3779af9.png";